var map = {
	"./Cell-Row-0-Col-0.png": 2588,
	"./Cell-Row-0-Col-1.png": 5477,
	"./Cell-Row-0-Col-2.png": 3374,
	"./Cell-Row-1-Col-0.png": 7269,
	"./Cell-Row-1-Col-1.png": 1356,
	"./Cell-Row-1-Col-2.png": 8935
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8780;